import { paymentApi } from "@/lib/payment-api";

export function useRechargeMutation() {
  return paymentApi.useMutation("post", "/v1/recharges/pix");
}
